import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AccessControlService } from "../pages/auth/services/access-control.service";

export const permissionGuard = (
  permission: string,
  options: { retryAfterSubscriptionRecovery?: boolean } = {},
): CanActivateFn => (_route, state) => {
  const access = inject(AccessControlService);
  const router = inject(Router);
  return access.hasPermission(permission) || router.createUrlTree(["/home/403-forbidden"], {
    queryParams: options.retryAfterSubscriptionRecovery === false ? undefined : { returnUrl: state.url },
  });
};
